import { actionsAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  suppliersDetail: {},
  suppliersCount: null,
  suppliersList: [],
  groupsList: [],
  groupsCount: null,
  segmentsList: [],
  segmentsCount: null,
  contactsList: [],
  changeShortcuts: false,
  retrieveLoader: false,
  createLoader: false,
  deleteLoader: false
}

export default {
  namespaced: true,
  state,
  actions: actionsAbstract,
  mutations: {
    ...mutationsAbstract,
    RESET_LIST (state) {
      state.suppliersList = []
      state.suppliersCount = null
      state.segmentsList = []
      state.segmentsCount = null
    },
    SET_SUPPLIERS_LIST (state, list) {
      state.suppliersList = list
    }
  }
}
